import React from 'react';

//Components
import { Link } from 'react-router-dom';

//Styles
import Styles from './Notifications.module.scss';

import { ROUTER_URL } from '../../const/ROUTER_URL';

//Utils
import classNames from 'class-names';

const Notification = ({ className, notification: { id, photo_url: photoURL, name, description } }) => (
    <Link
        to={ROUTER_URL.NOTIFICATIONS_PROMOTION_ID({ promotionId: id })}
        className={classNames(className, Styles.container, 'bg-white rounded')}
    >
        <img className={'w-100 rounded-top'} src={photoURL} alt=""/>

        <div className={'p-3'}>
            <h5 style={{ fontSize: '17px !important' }} className={'font-weight-bold text-dark'}>{name}</h5>
            <p className={classNames('text-dark', Styles.description)}>
                {description}
            </p>
        </div>
    </Link>
);

export default Notification
